<template>
  <div class="main_profile_wrapper">
    <div class="main_info_wrapper mb-5">
      <div class="info">
        <img
          class="img"
          src="../../../assets/new-theme/profile/Image wrap.png"
          alt=""
        />
      </div>
      <div class="info_data">
        <div class="wrap_one">
          <div class="main_user_img_wrapper">
            <img class="user_img" :src="image" alt="user image" />
          </div>
          <div>
            <span class="name d-block"
              >{{ userData.first_name }} {{ userData.last_name }}</span
            >
            <span class="email d-block">{{ userData.email }}</span>
          </div>
        </div>
        <div class="buttons_links" v-if="!$route.params.id">
          <button class="btn_1" @click="switchToPersonalProfile()">
            <img
              class="img"
              src="../../../assets/new-theme/profile/edit-05.png"
              alt=""
            />
            <span>{{ localization('Edit your Account') }}</span>
          </button>
          <button class="btn_2" @click="toggleModalShare()">
            <img
              class="img"
              src="../../../assets/new-theme/profile/share-07.png"
              alt=""
            />
            <span>{{localization('Share')}}</span>
          </button>
        </div>
        <div class="buttons_links" v-else >
          <button class="btn_1" @click="switchToPersonalProfile($route.params.id)" v-if="hasPermission('edit_institution_users')" >
            <img
              class="img"
              src="../../../assets/new-theme/profile/edit-05.png"
              alt=""
            />
            <span>{{ localization('Edit Account') }}</span>
          </button>
          <!-- Print Student Notebook Button REMOVED from here - moved into UserPattern -->
        </div>
      </div>
    </div>

    <!-- Start Patterns -->

    <UserPattern
      :userScore="userScore"
      :validScore="!userData.invalid_score"
      :visible="true"
      :showPrintNotebook="userInLaunchCardGroup && !!$route.params.id"
      @print-notebook="printStudentNotebook"
    ></UserPattern>
    <!-- End Patterns -->

    <!-- Start Your Learner Type -->
    <div class="learner_wrapper">
      <h2 class="main_title ">{{localization('Your Learner Type')}}</h2>
      <div class="main_learn_card mt-3">
        <div class="mb-3">
          <img
            class="img"
            src="../../../assets/new-theme/profile/Featured icon.png"
            alt=""
          />
        </div>
        <div>
          <span class="pattern_name">{{localization(userData.classification)}} {{localization('Learner')}} </span>
        </div>
        <!-- <p class="mb-0 text">
          The {{userData.classification}} Learner uses three or more Patterns at the Use First
          level.
        </p> -->
        <div class="mt-3 mb-3">
          <!-- <span class="d-block Characteristics mb-3">{{localization('Characteristics')}}</span>
          <ul class="list_items">
            <li class="item_in_list mt-1">
              {{localization('Prefers to lead rather than be led.')}}
            </li>
            <li class="item_in_list mt-1">
              {{localization('Prefers to control plans, ideas, talks, decisions, processes, and outcomes independently.')}}
            </li>
          </ul> -->
          <div class="description_type">
            <p class="text_type" v-if="userData.classification == 'Bridge'">
              {{ localization("The Bridge Learner uses all Patterns at a Use as Needed level. Your Patterns serve a helpful role by leading from the middle. Bridge learners are team catalysts. The Bridge learner can close the gap of understanding between learners who have Use First and Avoid Patterns.") }}
            </p>
            <p class="text_type" v-if="userData.classification == 'Dynamic'">
              <!-- {{ localization("dynamic tool tip") }} -->
              <ul>
                <li class="mb-2">
                  {{localization('Dynamic is the combination of Learning Patterns that uses at least one Pattern at the Use First level, while the remaining ones are any combination of another Use First, Use as Needed, or Avoid.')}}
                </li>
                <li class="mb-2">
                  {{ localization("You experience yourself shifting from the use of one Pattern to another, particularly when you move from your Use First Patterns to those you Avoid.") }}
                </li>
                <li class="mb-2">
                  {{ localization("As a Dynamic learner, you can relate to others well and understand how they use their Learning Patterns.") }}
                </li>
                <li class="mb-2">
                  {{ localization("You can identify when a colleague or supervisor is shifting from one Pattern to another and are able to sense when others in your work setting are having their Pattern needs ignored.") }}
                </li>
              </ul>
            </p>
            <p
              class="text_type"
              v-if="userData.classification == 'Strong-Willed Learner'"
            >
              {{ localization("The Strong-Willed Learner uses three or more Patterns at the Use First level. Strong-Willed learners seek opportunities to lead rather than be led. Your Patterns would have you prefer to control the plan, the ideas, the talks, the decisions, the processes, and the outcomes and do it all yourself. Understanding how your Patterns affect those around you is particularly important when you are a Strong-Willed Learner.") }}
            </p>
          </div>
        </div>
        <!-- <p class="mb-0 text">
          {{localization("It's crucial to understand how your Patterns impact those around you.")}}
        </p> -->
        <!-- <div class="mt-3 learn_more">
          <span class="color more">Learn more</span>
          <img
            class="img"
            src="../../../assets/new-theme/profile/arrow-right.png"
            alt=""
          />
        </div> -->
      </div>
    </div>
    <!-- End Your Learner Type -->

    <!-- Use Your Learning Patterns -->
    <div class="learner_patterns_wrapper">
      <h2 class="main_title ">
        {{localization("Use Your Learning Patterns")}}
      </h2>
      <p class="mb-0 text">
        {{localization("Add your own task and discover what patterns are needed to successfully complete it.")}}
      </p>
      <div class="main_cards mt-3">
        <div class="card_item">
          <div class="mb-3">
            <img
              class="img"
              src="../../../assets/new-theme/profile/book.png"
              alt=""
            />
          </div>
          <div class="mb-4">
            <span class="title mb-2 d-block">
              {{localization("Study-related task")}}
            </span>
            <p class="mb-0 description">
              {{localization("Add new tasks in math, reading, writing, study skills, science, social studies, etc")}}...
            </p>
          </div>
          <div>
            <button class="lci_btn " @click="ToggleTaskModal">
              <img
                class="img"
                src="../../../assets/new-theme/profile/plus.png"
                alt=""
              />
              <span>
                {{localization("Add a new study-related task")}}
              </span>
            </button>
          </div>
        </div>
        <div class="card_item">
          <div class="mb-3">
            <img
              class="img"
              src="../../../assets/new-theme/profile/wallet.png"
              alt=""
            />
          </div>
          <div class="mb-4">
            <span class="title mb-2 d-block">
              {{localization("Work-related task")}}
            </span>
            <p class="mb-0 description">
              {{localization("Add new tasks in time management, team interaction, meeting preparation, etc")}}...
            </p>
          </div>
          <div>
            <button class="lci_btn " @click="ToggleTaskModal2">
              <img
                class="img"
                src="../../../assets/new-theme/profile/plus.png"
                alt=""
              />
              <span>
                {{localization("Add a new work-related task")}}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Use Your Learning Patterns -->

    <!-- Use Your Personal Patterns -->
    <!-- <div class="your_personal_wrapper" v-if="userData.role != 'basic' && userData.role != 'institution basic'">
      <h2 class="main_title ">
        {{localization("Build Your Personal Work Profile (PWP)")}}
      </h2>
      <p class="mb-0 text">
        {{localization("And see if the job is the right fit for you!")}}
      </p>
      <div class="mt-3">
        <button class="lci_btn " @click="switchToPWP">
          <span>
            {{localization("Get strategies!")}}
          </span>
          <img
            class="img"
            src="../../../assets/new-theme/profile/arrow-right-white.png"
            alt=""
          />
        </button>
      </div>
    </div> -->

    <!--  -->
    <!-- <div class="video_player_wrapper">
      <h2 class="main_title mt-0">Learning Material</h2>
      <p class="mb-0 text">
        Discover a step-by-step videos about learning patterns and the different learner types.
      </p>
      <div class="mt-3 text-center">
        <div class="d-flex justify-content-center">
          <img
            class="img"
            src="@/assets/new-theme/profile/video_player.png"
            alt=""
          />

        </div>
        <div class="d-flex justify-content-center mt-3">

            <button class="discover_video_btn">
          <img
            class="img"
            src="@/assets/new-theme/profile/video_icon.png"
            alt=""
          />
          <span>Discover other videos</span>
        </button>
        </div>

      </div>
    </div> -->

    <!-- Personalize Your Profile-->
    <!-- <div class="personalize_profile" v-if="userData.role != 'basic' && userData.role != 'institution basic' ">
      <div>
        <div class="item_wrap">
          <h2 class="main_title white_text mb-0 mt-0" >
            {{localization("Build Your Personal Work Profile (PWP) Recommended!")}}
          </h2>
        </div>
        <p class="mb-0 text white_text mt-2">
          {{localization("And share with others how you learn, work, and interact with others.")}}
        </p>
      </div>
      <div class="last_section">
        <img
          role="button"
          @click="switchToPWP"
          class="img"
          src="@/assets/new-theme/profile/arrow-right.png"
          alt=""
        />
      </div>
    </div> -->

    <!--  Start Share -->
    <ShareModal
      :showHideModalShare.sync="showHideModalShare"
      @close="toggleModalShare"
      @submit="submitShared"
      :title="`${localization('Share your profile')}`"
      :description="`${localization('Share your personalized profile and learning patterns score with others to let them know how you learn, work, and interact with others.')}`"
    ></ShareModal>
    <!--  End Share -->
    <!-- Task Modal // in school task -->
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="resetForm"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/file.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title">
          {{ localization("Add a new study-related task") }}
        </h3>
        <p class="description">
          {{ localization("Add your own task and discover what patterns are needed to successfully complete it.") }}
        </p>
      </div>

      <!-- Task Form -->
      <el-form :model="task" :rules="rules" ref="taskForm" class="task-form">
        <div class="flex justify-content-between" style="gap: 10px">
          <div class="flex-grow-1">
            <!-- Task Name -->
            <el-form-item prop="name">
              <AppInputLabel :text="`${localization('Name your task')}`" :star="true"></AppInputLabel>
              <el-input
                class="new_theme_custom_input"
                v-model="task.name"
                :placeholder="`${localization('Give your task a name')}`"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex-grow-1">
            <!-- Task Topic -->
            <el-form-item prop="topic_id">
              <AppInputLabel :text="`${localization('Task category')}`" :star="true"></AppInputLabel>
              <el-select
                v-model="task.topic_id"
                clearable
                :placeholder="`${localization('Topic')}`"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in standardTopicsData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- Task Description -->
        <el-form-item prop="description">
          <AppInputLabel :text="`${localization('Task description')}`" :star="true"></AppInputLabel>
          <el-input
            class="new_theme_custom_input input_with_custom_text_area"
            type="textarea"
            v-model="task.description"
            :placeholder="`${localization('Add task description')}`"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="or_modal mb-3">
        {{ localization("or") }}
      </div>
      <!-- File Upload Section -->
      <div class="file-upload">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :on-change="handleUploadSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :auto-upload="false"
          :on-remove="handleRemove"
          :show-file-list="false"
          accept="image/apng, image/jpeg, image/png, image/webp"
          :disabled="loading"
        >
          <div v-if="!loading">
            <img src="@/assets/new-theme/upload.png" alt="upload" />
            <div class="el-upload__text">
              <span class="click_upload">
                  {{ localization("Click to upload") }}
              </span>
                  {{ localization("or drag and drop") }}
            </div>
            <div class="el-upload__tip">
              {{ localization("Supported") }}: PNG, JPG, (Max 5MB)
            </div>
          </div>
          <div
            class="d-flex spin_modal"
            v-loading="loading"
            element-loading-text="waiting to extract photo..."
          ></div>
        </el-upload>
      </div>

      <!-- Display Uploaded Files with Delete Option -->
      <div v-if="fileList && fileList.length > 0" class="uploaded-files">
        <ul>
          <li v-for="file in fileList" :key="file.name" class="file-item">
            <div class="d-flex" style="gap: 10px">
              <div>
                <img src="@/assets/new-theme/file.png" alt="" />
              </div>
              <div>
                <span class="file-name">{{ file.name }}</span>
                <span class="d-block file_size"
                  >{{ (file.size / 1024).toFixed(2) }} KB</span
                >
              </div>
            </div>
            <i class="el-icon-delete file-delete" @click="removeFile(file)"></i>
          </li>
        </ul>
      </div>

      <!-- Footer Buttons -->
      <div class="lci_modal_buttons mt-4">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save  lci_btn_modal_cancel">
          {{ localization("Confirm") }}
        </button>
      </div>
    </el-dialog>
    <!-- End Add Task Modal // in school task -->

    <!-- Task Modal // at work-->
    <el-dialog
      title=""
      :visible.sync="dialogVisible2"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="resetForm2"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/file.png" alt="file" />
          <img
            @click="resetForm2"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title">
          {{ localization("Add a new work-related task") }}
        </h3>
        <p class="description">
          {{ localization("Add your own task and discover what patterns are needed to successfully complete it.") }}
        </p>
      </div>

      <!-- Task Form -->
      <el-form :model="task2" :rules="rules2" ref="taskForm2" class="task-form">
        <div class="flex justify-content-between" style="gap: 10px">
          <div class="flex-grow-1">
            <!-- Task Name -->
            <el-form-item prop="name">
              <AppInputLabel :text="`${localization('Name your task')}`" :star="true"></AppInputLabel>
              <el-input
                class="new_theme_custom_input"
                v-model="task2.name"
                :placeholder="`${localization('Give your task a name')}`"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex-grow-1">
            <!-- Task Topic -->
            <el-form-item prop="topic_id">
              <AppInputLabel :text="`${localization('Task category')}`" :star="true"></AppInputLabel>
              <el-select
                v-model="task2.topic_id"
                clearable
                :placeholder="`${localization('Topic')}`"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in atWorkTasksTopics"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- Task Description -->
        <el-form-item prop="description">
          <AppInputLabel :text="`${localization('Task description')}`" :star="true"></AppInputLabel>
          <el-input
            class="new_theme_custom_input input_with_custom_text_area"
            type="textarea"
            v-model="task2.description"
            :placeholder="`${localization('Add task description')}`"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="or_modal mb-3">
        {{ localization("or") }}
      </div>
      <!-- File Upload Section -->
      <div class="file-upload">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :on-change="handleUploadSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :auto-upload="false"
          :on-remove="handleRemove"
          :show-file-list="false"
          accept="image/apng, image/jpeg, image/png, image/webp"
          :disabled="loading"
        >
          <div v-if="!loading">
            <img src="@/assets/new-theme/upload.png" alt="upload" />
            <div class="el-upload__text">
              <span class="click_upload">{{ localization("Click to upload") }}</span> {{ localization("or drag and drop") }}
            </div>
            <div class="el-upload__tip">
              {{ localization("Supported") }}: PNG, JPG, (Max 5MB)
            </div>
          </div>
          <div
            class="d-flex spin_modal"
            v-loading="loading"
            element-loading-text="waiting to extract photo..."
          ></div>
        </el-upload>
      </div>

      <!-- Display Uploaded Files with Delete Option -->
      <div v-if="fileList && fileList.length > 0" class="uploaded-files">
        <ul>
          <li v-for="file in fileList" :key="file.name" class="file-item">
            <div class="d-flex" style="gap: 10px">
              <div>
                <img src="@/assets/new-theme/file.png" alt="" />
              </div>
              <div>
                <span class="file-name">{{ file.name }}</span>
                <span class="d-block file_size"
                  >{{ (file.size / 1024).toFixed(2) }} KB</span
                >
              </div>
            </div>
            <i class="el-icon-delete file-delete" @click="removeFile(file)"></i>
          </li>
        </ul>
      </div>

      <!-- Footer Buttons -->
      <div class="lci_modal_buttons mt-4">
        <button @click="resetForm2" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm2" class="lci_btn save  lci_btn_modal_cancel">
          {{ localization("Confirm") }}
        </button>
      </div>
    </el-dialog>
    <!-- End Add Task Modal // at work -->

    <!-- ====== Print Student Notebook – hidden print container ====== -->
    <div class="print-only-block" ref="notebookPrintContainer" v-if="notebookPrintData">
      <div class="notebook-print-wrapper">
        <!-- User Header -->
        <div class="nb-print-user-header text-center border-bottom pb-4 mb-4">
          <h2 class="nb-user-name font-weight-bold mb-1">{{ userData.first_name }} {{ userData.last_name }}</h2>
          <p class="nb-user-email text-muted mb-3">{{ userData.email }}</p>
          <!-- Pattern Scores (2x2 Grid matching attachment style) -->
          <div class="nb-print-score-grid">
            <!-- Sequence Card -->
            <div class="nb-print-score-card" style="background-color: #39c;">
              <div class="nb-card-top-name">{{ localization('Sequence (S)') }}</div>
              <div class="nb-card-middle-row">
                <div class="nb-card-score">{{ userScore.sequence }}</div>
                <div class="nb-card-level">{{ getScoreLabel(userScore.sequence) }}</div>
              </div>
              <div class="nb-card-bottom-icon">
                <i class="fa fa-chevron-down"></i>
              </div>
            </div>

            <!-- Precision Card -->
            <div class="nb-print-score-card" style="background-color: #3c3;">
              <div class="nb-card-top-name">{{ localization('Precision (P)') }}</div>
              <div class="nb-card-middle-row">
                <div class="nb-card-score">{{ userScore.precision }}</div>
                <div class="nb-card-level">{{ getScoreLabel(userScore.precision) }}</div>
              </div>
              <div class="nb-card-bottom-icon">
                <i class="fa fa-chevron-down"></i>
              </div>
            </div>

            <!-- Technical Reasoning Card -->
            <div class="nb-print-score-card" style="background-color: #f93;">
              <div class="nb-card-top-name">{{ localization('Technical Reasoning (T)') }}</div>
              <div class="nb-card-middle-row">
                <div class="nb-card-score">{{ userScore.technical_reasoning }}</div>
                <div class="nb-card-level">{{ getScoreLabel(userScore.technical_reasoning) }}</div>
              </div>
              <div class="nb-card-bottom-icon">
                <i class="fa fa-chevron-down"></i>
              </div>
            </div>

            <!-- Confluence Card -->
            <div class="nb-print-score-card" style="background-color: #c36;">
              <div class="nb-card-top-name">{{ localization('Confluence (C)') }}</div>
              <div class="nb-card-middle-row">
                <div class="nb-card-score">{{ userScore.confluence }}</div>
                <div class="nb-card-level">{{ getScoreLabel(userScore.confluence) }}</div>
              </div>
              <div class="nb-card-bottom-icon">
                <i class="fa fa-chevron-down"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Groups and Answers -->
        <div
          v-for="group in notebookPrintData.groups"
          :key="'print-group-' + group.id"
          class="print-page-break mb-5"
        >
          <!-- Group Header -->
          <div class="nb-group-header mb-4 p-3 border-bottom" style="background: #f9f5ff; border-left: 5px solid #7f56d9;">
            <h3 class="font-weight-bold text-dark mb-1" style="font-size: 1.5rem;">
              {{ localization('Group') }}: {{ group.name }}
            </h3>
            <span class="badge badge-primary px-3 py-2 text-white" style="font-size: 0.9rem; background-color: #7f56d9;">
              {{ localization('Topic') }}: {{ group.topicName }}
            </span>
          </div>

          <!-- Subtopics -->
          <div
            v-for="subtopic in group.subtopics"
            :key="'print-subtopic-' + subtopic.id"
            class="print-page-break mb-4"
          >
            <!-- Subtopic Title -->
            <div class="subtopic-print-header mb-3 border-left pl-3" style="border-width: 4px !important; border-color: #7f56d9 !important;">
              <h4 class="font-weight-bold text-dark mb-1" style="font-size: 1.3rem;">
                {{ subtopic.name }}
              </h4>
              <p class="text-muted small mb-0">{{ subtopic.description }}</p>
            </div>

            <!-- Subtopic Notebook -->
            <div v-if="subtopic.student_notebook" class="mb-4 student_notebook_print_card p-3 border rounded">
              <h5 class="notebook_card_title font-weight-bold text-dark mb-3" style="font-size: 1.15rem;">
                <i class="fa fa-book text-primary mr-2" style="color: #7f56d9;"></i>
                {{ subtopic.student_notebook_title || localization('Students Notebook') }}
              </h5>
              <div
                class="student_notebook_wrapper"
                v-html="formatNotebookHtml(subtopic.student_notebook, group.schoolGrade)"
              ></div>
            </div>

            <!-- Components & Question Cards -->
            <div v-if="subtopic.components && subtopic.components.length > 0">
              <div
                v-for="component in subtopic.components"
                :key="component.id"
                class="component-print-block mb-3 p-3 border rounded page-break-inside-avoid"
              >
                <h5 class="font-weight-bold text-secondary mb-2" style="font-size: 1.1rem;">
                  {{ component.title }}
                </h5>
                <div class="component-body mb-3 text-muted small" v-if="component.body" v-html="component.body"></div>

                <div v-if="component.question_cards && component.question_cards.length > 0" class="mt-2">
                  <div v-for="(qCard, qIndex) in component.question_cards" :key="qCard.id" class="mb-3 page-break-inside-avoid">
                    <!-- MCQ Type -->
                    <div v-if="qCard.type === 'mcq' || (qCard.choices && qCard.choices.length > 0)">
                      <div class="d-flex align-items-start mb-2 pl-2 border-left" style="border-width: 3px !important; border-color: #7f56d9 !important;">
                        <span class="badge badge-secondary mr-2 mt-1 text-white" style="background-color: #7f56d9;">
                          {{ qIndex + 1 }}
                        </span>
                        <span class="font-weight-bold text-dark" style="font-size: 0.9rem;">
                          {{ qCard.question }}
                        </span>
                      </div>
                      <div class="pl-4 mt-2">
                        <div
                          v-for="choice in qCard.choices"
                          :key="choice.id"
                          class="choice-row d-flex align-items-center mb-1 p-2 rounded border"
                          :style="qCard.student_answer === choice.id ? 'background-color: #f9f5ff; border-color: #7f56d9; border-left: 4px solid #7f56d9;' : 'background-color: #ffffff; border-color: #eaecf0;'"
                        >
                          <i v-if="qCard.student_answer === choice.id" class="fa fa-dot-circle-o text-primary mr-2" style="color: #7f56d9;"></i>
                          <i v-else class="fa fa-circle-o text-muted mr-2"></i>
                          <span :class="{'text-primary font-weight-bold': qCard.student_answer === choice.id, 'text-secondary': qCard.student_answer !== choice.id}">
                            {{ choice.text }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Essay Type -->
                    <div v-else class="essay-question-container text-left">
                      <div class="essay-question-header">
                        <div class="essay-step-label">
                          Step {{ parseQuestionCard(qCard, qIndex).stepNumber }}: <strong>{{ parseQuestionCard(qCard, qIndex).stepName }}</strong>
                        </div>
                        <div class="essay-main-question">
                          {{ parseQuestionCard(qCard, qIndex).mainQuestion }}
                        </div>
                        <div class="essay-help-text" v-if="parseQuestionCard(qCard, qIndex).helpText" v-html="formatHelpText(parseQuestionCard(qCard, qIndex).helpText)">
                        </div>
                      </div>
                      <div class="essay-question-body">
                        <div class="essay-answer-preview">
                          {{ qCard.student_answer || qCard.answer || localization('No answer submitted yet.') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center p-3 bg-light rounded text-muted small">
              {{ localization('No components or questions defined for this subtopic.') }}
            </div>
          </div>
        </div>

        <!-- Standalone Notebooks -->
        <div v-if="notebookPrintData.standaloneNotebooks && notebookPrintData.standaloneNotebooks.length > 0">
          <h3 class="nb-section-title mt-4">{{ localization('Students Notebook') }}</h3>
          <div
            v-for="subtopic in notebookPrintData.standaloneNotebooks"
            :key="'print-standalone-notebook-' + subtopic.id"
            class="mb-4 student_notebook_print_card p-3 border rounded print-page-break"
          >
            <h3 class="notebook_card_title font-weight-bold text-dark mb-3" style="font-size: 1.3rem; border-left: 4px solid #7f56d9; padding-left: 10px;">
              {{ subtopic.name || localization('Students Notebook') }}
            </h3>
            <div
              class="student_notebook_wrapper"
              v-html="formatNotebookHtml(subtopic.body || subtopic.student_notebook)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- ====== End Print Container ====== -->

    <!-- ====== Printing Loader Overlay ====== -->
    <transition name="fade-loader">
      <div class="notebook-print-loader-overlay" v-if="isPrintingNotebook">
        <div class="notebook-print-loader-card">
          <div class="nb-loader-spinner"></div>
          <p class="nb-loader-text">{{ localization('Generating PDF, please wait…') }}</p>
        </div>
      </div>
    </transition>
    <!-- ====== End Printing Loader ====== -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import request from "@/utils/request";
export default {
  name: "ProfileView",
  data() {
    return {
      showHideModalShare: false,
      dialogVisible: false,
      dialogVisible2: false,
      // Print Student Notebook
      isPrintingNotebook: false,
      notebookPrintData: null,
      userInLaunchCardGroup: false,
      task: {
        name: "",
        topic_id: "",
        description: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: this.localization("Please enter the task name"),
            trigger: "blur"
          }
        ],
        topic_id: [
          {
            required: true,
            message: this.localization("Please enter the task topic"),
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: this.localization("Please enter a task description"),
            trigger: "blur"
          }
        ]
      },
      loading: false,
      fileList: [],
      task2: {
        name: "",
        topic_id: "",
        description: ""
      },
      rules2: {
        name: [
          {
            required: true,
            message: this.localization("Please enter the task name"),
            trigger: "blur"
          }
        ],
        topic_id: [
          {
            required: true,
            message: this.localization("Please enter the task topic"),
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: this.localization("Please enter a task description"),
            trigger: "blur"
          }
        ]
      }
    };
  },
   watch: {
    '$route'(to, from) {
      // Check if we're moving to/from profile routes
      if (to.path.includes('/new-theme/profile')) {
        this.getMainUserData();
      }
    }
  },
  computed: {
    mainUserId() {
      return this.$route.params.id ? this.$route.params.id : this.auth().id;
    },
    userScore() {
      return this.$store.getters["user/score"];
    },
    userData() {
      return this.$store.state.user.user;
    },
    image() {
      if (this.userData.image) {
        return `${process.env.VUE_APP_BASE_URL}/users/photo/${this.userData.image}`;
      }
      return "/static/img/lml-swerl.jpg";
    },
    standardTopicsData() {
      return this.$store.getters["topics/getStandardTopics"];
    },
    atWorkTasksTopics() {
      return this.$store.getters["user/getAtWorkTasksTopics"];
    }
  },
  methods: {
    // Get User Data And Set User Score
    getMainUserData() {

      this.$store.dispatch("user/user", this.mainUserId).then(() => {
        // Set the Selected User attribute
        this.selected = this.userData.selected_attributes;
        if(this.$route.params.id){
          // Check if this user belongs to any launch card group by checking all group cards
          request({
            url: `/group_cards/list`,
            method: 'POST',
            data: { limit: 1000 }
          }).then(response => {
            const cards = (response && response.groupCards) || [];
            const targetUserId = parseInt(this.$route.params.id);
            this.userInLaunchCardGroup = cards.some(card => {
              const members = card.usersGroupCards || [];
              return members.some(m => (m.user_id === targetUserId || m.id === targetUserId));
            });
          }).catch(err => {
            console.error('Error fetching group cards:', err);
            this.userInLaunchCardGroup = false;
          });
        }else{


        if (this.userData.invalid_score != null) {
          this.$router.push("/new-theme/instructions");
        }
          //if(this.userData.sequence ){
          //}else {
            //this.$router.push( '/new-theme/instructions' )
          //}
        }
      });
    },
    getProgressColor(key) {
      switch (key) {
        case "Precision":
          return "#3c3";
        case "Technical Reasoning":
          return "#f93";
        case "Confluence":
          return "#c36";
        case "Sequence":
          return "#39c";
      }
    },
    // Toggle Modal User Type
    toggleModalShare() {
      this.showHideModalShare = !this.showHideModalShare;
    },
    // Start Extract Photo => in school task
    ToggleTaskModal() {
      this.dialogVisible = !this.dialogVisible;
    },

    handleUploadSuccess(file, fileList) {
      this.fileList = fileList;
      this.handle_upload_file_img(file);
    },

    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("File size cannot exceed 5MB.");
      }
      return isLt5M;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    removeFile(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    },
    handle_upload_file_img(file) {
      this.loading = true;
      this.description_photo = file.raw;
      let payload = new FormData();
      payload.append("photo", file.raw);
      this.$store
        .dispatch("user/get_ocr_photo_description", payload)
        .then(response => {
          this.task.description = response.photo_description;
          this.loading = false;
          Swal.fire({
            title: "",
            icon: "success",
            text: `${this.localization("Please double check the extracted text!")}`,
            type: "success",
            confirmButtonText: `${this.localization("Ok")}`,
            confirmButtonClass: "btn btn-success ",
            buttonsStyling: false
          });
        });
      this.fileList = [];
      this.loading = false;
    },
    resetForm() {
      this.$refs.taskForm.resetFields();
      this.fileList = [];
      this.dialogVisible = false;
      // this.$v.$reset();
    },
    submitForm() {
      this.$refs.taskForm.validate(valid => {
        if (valid) {

          this.task['user_id'] = parseInt(this.$route.params.id);
          this.$store
            .dispatch("user/add_task", {
              query: this.task
            })
            .then(response => {
              this.dialogVisible = false;

              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });

              this.$router.push(`/new-theme/tasks/${response.task.id}`);
            })
            .catch(_ => {
              this.dialogVisible = false;
            });

          // Implement strategy generation logic
        } else {
          // this.$message.success("Form is valid. Strategies will be generated.");
          // this.$message.error("Please fill out all required fields.");
          return false;
        }
      });
    },

    submitShared(sharedEmails) {
      let payload = {
        emails: sharedEmails
      };


      this.$store.dispatch("user/sharing_profile_task", payload).then(() => {
        this.showHideModalShare = !this.showHideModalShare;
        Swal.fire({
          title: "",
          text: `${this.localization("Done")}`,
          confirmButtonText: `${this.localization("Ok")}`,
          icon: "success",
          confirmButtonClass: "btn btn-success",
          buttonsStyling: false
        });
      });
    },
    // End Extract Photo  => in school task

    //  Start At Work Task
    ToggleTaskModal2() {
      this.dialogVisible2 = !this.dialogVisible2;
    },
    resetForm2() {
      this.$refs.taskForm2.resetFields();
      this.fileList = [];
      this.dialogVisible2 = false;
      // this.$v.$reset();
    },
    submitForm2() {
      this.$refs.taskForm2.validate(valid => {
        if (valid) {
          this.task2['user_id'] = parseInt(this.$route.params.id);
          this.$store
            .dispatch("user/handleAddWorkTask", {
              query: this.task2
            })
            .then(response => {
              this.dialogVisible2 = false;

              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });

              this.$router.push(`/new-theme/at-work/${response.task.id}`);
            })
            .catch(_ => {
              this.dialogVisible2 = false;
            });
        } else {
          // this.$message.success("Form is valid. Strategies will be generated.");
          // this.$message.error("Please fill out all required fields.");
          return false;
        }
      });
    },
    // End At Work Task
    // switch t0 personal profile
    switchToPersonalProfile(userId) {
      this.$router.push({name: 'Personalize Your Profile', params: { id: userId }})
    },
    // End switch to personal profile
    switchToPWP() {
      this.$router.push("/new-theme/pwp");
    },

    // ===== Print Student Notebook =====
    getScoreLabel(score) {
      if (score == null) return '';
      const val = parseInt(score);
      if (val >= 25 && val <= 35) return this.localization('Use First');
      if (val >= 7 && val <= 17) return this.localization('Avoid');
      if (val >= 18 && val <= 24) return this.localization('As Needed');
      return '';
    },

    async printStudentNotebook() {
      const userId = this.$route.params.id;
      if (!userId) return;

      this.isPrintingNotebook = true;
      this.notebookPrintData = null;

      try {
        // 1. Fetch all group cards
        const groupsResponse = await request({
          url: `/group_cards/list`,
          method: 'POST',
          data: { limit: 1000 }
        });
        const allGroups = (groupsResponse && groupsResponse.groupCards) || [];
        const targetUserId = parseInt(userId);

        // Filter to groups where the user is a member
        const userGroups = allGroups.filter(card => {
          const members = card.usersGroupCards || [];
          return members.some(m => (m.user_id === targetUserId || m.id === targetUserId));
        });

        // 2. Fetch notebooks for this user
        const notebookResponse = await this.$store.dispatch(
          'students_notebook/GetStudentsNotebooks',
          { query: { user_id: userId, limit: 1000 } }
        );
        const notebooks = this.$store.getters['students_notebook/studentsNotebooks'] || [];

        // 3. For each group, load the full details (subtopics and answers)
        const groupsWithAnswers = [];
        for (const group of userGroups) {
          const firstTopic = group.topicsGroupCards && group.topicsGroupCards[0];
          const topicName = firstTopic ? firstTopic.topic_card_name : "";
          const schoolGrade = firstTopic && firstTopic.school_grade ? String(firstTopic.school_grade) : "";

          // Fetch subtopics answers for this group
          const subtopicIds = group.subTopicsCards ? group.subTopicsCards.map(s => s.id) : [];
          const subtopicPromises = subtopicIds.map(id => {
            return request({
              url: `/sub_topics_card/show/${id}`,
              method: "get",
              params: { user_id: userId, school_grade: schoolGrade }
            });
          });

          const subtopicResponses = await Promise.all(subtopicPromises);

          // Match notebooks for this group/subtopics
          const cleanGrade = g => g ? String(g).toLowerCase().replace(/grade\s*/i, '').trim() : '';
          const currentGrade = cleanGrade(schoolGrade);

          const subtopics = subtopicResponses.map(r => {
            const subtopic = r && r.subTopicsCard;
            if (subtopic) {
              const match = notebooks.find(n => {
                const notebookGrade = cleanGrade(n.school_grade);
                const gradeMatches = !currentGrade || !notebookGrade || notebookGrade === currentGrade;
                return n.sub_topic_card_id && String(n.sub_topic_card_id) === String(subtopic.id) && gradeMatches;
              });

              if (match && (match.body || match.student_notebook)) {
                subtopic.student_notebook = match.body || match.student_notebook;
                subtopic.student_notebook_title = match.name || subtopic.student_notebook_title || subtopic.name;
              } else if (!subtopic.student_notebook_title) {
                subtopic.student_notebook_title = subtopic.name;
              }
            }
            return subtopic;
          }).filter(Boolean);

          groupsWithAnswers.push({
            id: group.id,
            name: group.name,
            topicName: topicName,
            schoolGrade: schoolGrade,
            subtopics: subtopics
          });
        }

        // 4. Standalone grade notebooks that are not linked to any subtopics
        const cleanGrade = g => g ? String(g).toLowerCase().replace(/grade\s*/i, '').trim() : '';
        const uniqueGrades = [...new Set(groupsWithAnswers.map(g => cleanGrade(g.schoolGrade)).filter(Boolean))];

        const standaloneNotebooks = notebooks.filter(n => {
          if (n.sub_topic_card_id) return false;
          const notebookGrade = cleanGrade(n.school_grade);
          if (uniqueGrades.length === 0) return true;
          return !notebookGrade || uniqueGrades.includes(notebookGrade);
        });

        this.notebookPrintData = {
          groups: groupsWithAnswers,
          standaloneNotebooks: standaloneNotebooks
        };

        // Wait for Vue to render the print container
        await this.$nextTick();
        await this.$nextTick();

        this._executeNotebookPrint();
      } catch (e) {
        console.error('Error fetching notebook/answers data for print:', e);
        this.isPrintingNotebook = false;
        this.notebookPrintData = null;
      }
    },

    getGradeTitle(schoolGrade) {
      if (!schoolGrade) return "Grade 1 ELA";
      let str = String(schoolGrade).trim();
      if (!/grade/i.test(str)) {
        str = `Grade ${str}`;
      }
      if (!/ela/i.test(str)) {
        str = `${str} ELA`;
      }
      return str;
    },

    formatNotebookHtml(rawHtml, schoolGrade) {
      if (!rawHtml) return "";
      let html = rawHtml;
      const studentName = `${this.userData.first_name || ''} ${this.userData.last_name || ''}`.trim() || "___";
      const gradeTitle = this.getGradeTitle(schoolGrade);
      const seq = (this.userData && this.userData.sequence != null) ? this.userData.sequence : "___";
      const prec = (this.userData && this.userData.precision != null) ? this.userData.precision : "___";
      const tech = (this.userData && this.userData.technical_reasoning != null) ? this.userData.technical_reasoning : "___";
      const conf = (this.userData && this.userData.confluence != null) ? this.userData.confluence : "___";

      // Replace student name
      if (html.includes('notebook-student-name')) {
        html = html.replace(/(<span[^>]*class="[^"]*notebook-student-name[^"]*"[^>]*>)(.*?)(<\/span>)/gi, `$1${studentName}$3`);
      } else {
        html = html.replace(/THIS NOTEBOOK BELONGS TO:?/gi, `THIS NOTEBOOK BELONGS TO: <span class="notebook-student-name" style="color: #7f56d9;">${studentName}</span>`);
      }
      html = html.replace(/\{\{\s*STUDENT_NAME\s*\}\}/g, studentName);

      // Replace grade title according to student level / group school_grade
      if (html.includes('notebook-grade-title')) {
        html = html.replace(/(<h2[^>]*class="[^"]*notebook-grade-title[^"]*"[^>]*>)(.*?)(<\/h2>)/gi, `$1${gradeTitle}$3`);
      } else {
        html = html.replace(/<h2([^>]*)>Grade\s*\d+\s*ELA<\/h2>/gi, `<h2$1 class="notebook-grade-title">${gradeTitle}</h2>`);
        html = html.replace(/Grade\s*\d+\s*ELA/gi, gradeTitle);
      }
      html = html.replace(/\{\{\s*SCHOOL_GRADE\s*\}\}/g, gradeTitle);

      // Replace class-based score placeholders
      html = html.replace(/(<span[^>]*class="[^"]*notebook-score-sequence[^"]*"[^>]*>)(.*?)(<\/span>)/gi, `$1${seq}$3`);
      html = html.replace(/(<span[^>]*class="[^"]*notebook-score-precision[^"]*"[^>]*>)(.*?)(<\/span>)/gi, `$1${prec}$3`);
      html = html.replace(/(<span[^>]*class="[^"]*notebook-score-technical_reasoning[^"]*"[^>]*>)(.*?)(<\/span>)/gi, `$1${tech}$3`);
      html = html.replace(/(<span[^>]*class="[^"]*notebook-score-confluence[^"]*"[^>]*>)(.*?)(<\/span>)/gi, `$1${conf}$3`);

      // Replace label-adjacent underlines
      html = html.replace(/(Sequence:?\s*<\/span>\s*<span[^>]*>)(___)(<\/span>)/gi, `$1${seq}$3`);
      html = html.replace(/(Precision:?\s*<\/span>\s*<span[^>]*>)(___)(<\/span>)/gi, `$1${prec}$3`);
      html = html.replace(/(Technical Reasoning:?\s*<\/span>\s*<span[^>]*>)(___)(<\/span>)/gi, `$1${tech}$3`);
      html = html.replace(/(Confluence:?\s*<\/span>\s*<span[^>]*>)(___)(<\/span>)/gi, `$1${conf}$3`);

      // Fallback bracket placeholders
      html = html.replace(/\{\{\s*SCORE_SEQUENCE\s*\}\}/g, seq);
      html = html.replace(/\{\{\s*SCORE_PRECISION\s*\}\}/g, prec);
      html = html.replace(/\{\{\s*SCORE_TECHNICAL_REASONING\s*\}\}/g, tech);
      html = html.replace(/\{\{\s*SCORE_CONFLUENCE\s*\}\}/g, conf);

      return html;
    },

    _executeNotebookPrint() {
      const printEl = this.$refs.notebookPrintContainer;
      if (!printEl) {
        this.isPrintingNotebook = false;
        return;
      }

      // Make the hidden container visible for print
      const SHOW_PROPS = {
        position: 'static',
        left: 'auto',
        top: 'auto',
        width: '100%',
        height: 'auto',
        overflow: 'visible',
        visibility: 'visible',
        display: 'block'
      };
      Object.entries(SHOW_PROPS).forEach(([prop, val]) => {
        printEl.style.setProperty(prop, val, 'important');
      });

      // Inject global print styles
      this._injectNotebookPrintStyle();

      const originalTitle = document.title;
      document.title = `${this.userData.first_name}_${this.userData.last_name}_Notebook`;

      const cleanup = () => {
        document.title = originalTitle;
        Object.keys(SHOW_PROPS).forEach(prop => printEl.style.removeProperty(prop));
        this.notebookPrintData = null;
        this.isPrintingNotebook = false;
        this._removeNotebookPrintStyle();
        window.removeEventListener('afterprint', cleanup);
      };
      window.addEventListener('afterprint', cleanup);

      requestAnimationFrame(() => {
        this.isPrintingNotebook = false;
        window.print();
      });
    },

    _injectNotebookPrintStyle() {
      const existing = document.getElementById('__notebook-print-style');
      if (existing) existing.remove();
      const style = document.createElement('style');
      style.id = '__notebook-print-style';
      style.textContent = `
        @media print {
          .sidebar, .navbar, .footer,
          #app > .wrapper > .sidebar,
          #app > .wrapper > .navbar {
            display: none !important;
          }
          .main_profile_wrapper > *:not(.print-only-block) {
            display: none !important;
          }
          html, body, #app, .wrapper, .main-panel, .content, .main_profile_wrapper {
            position: static !important;
            width: 100% !important;
            height: auto !important;
            overflow: visible !important;
            background: #fff !important;
          }
          @page { size: auto; margin: 4mm; }
        }
      `;
      document.head.appendChild(style);
    },

    _removeNotebookPrintStyle() {
      const style = document.getElementById('__notebook-print-style');
      if (style) style.remove();
    }
    // ===== End Print Student Notebook =====
  },
  beforeMount(){
    this.getMainUserData()
  },
  mounted() {
    this.$store.dispatch("topics/handlerStandardTopics");
    this.$store.dispatch("user/handlerWorkTopics");
  }
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;

  .main_title {
    color: #101828;
    font-weight: 600;
    font-size: 20px;
    &.white_text {
      color: #fff;
    }
  }

  // Start Your Learner Typ
  .learner_wrapper {
    margin-top: 40px;
    .main_learn_card {
      box-shadow: 0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814;
      border-radius: 8px;
      border: 1px solid #eaecf0;
      padding: 24px;
      .pattern_name {
        font-weight: 500;
        font-size: 18px;
        color: #101828;
        margin-bottom: 10px;
        display: block;
      }
      .text {
        color: #667085;
        font-weight: 400;
        font-size: 16px;
      }
      .Characteristics {
        font-weight: 400;
        font-size: 16px;
        color: #667085;
      }
      .list_items {
        margin-bottom: 0 !important;
        margin-left: 0;
      }
      .item_in_list {
        font-weight: 400;
        font-size: 15px;
        color: #667085;
      }
    }
    .learn_more {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .more {
      font-weight: 500;
      font-size: 16px;
    }
  }
  // Use Your Learning Patterns
  .learner_patterns_wrapper {
    margin-top: 40px;
    .text {
      color: #667085;
      font-weight: 400;
      font-size: 16px;
    }
    .main_cards {
      display: flex;
      justify-content: space-between;
      gap: 4%;
      flex-wrap: wrap; // Fix horizontal scroll
      .card_item {
        border-radius: 8px;
        border: 1px solid #eaecf0;
        padding: 24px;
        width: calc(96% / 2);

        @media (max-width: 768px) {
          width: 100%;
          margin-bottom: 20px;
        }

        .title {
          color: #101828;
          font-weight: 600;
          font-size: 18px;
        }
        .description {
          color: #667085;
          font-weight: 400;
          font-size: 16px;
        }
        .lci_btn {
          background-color: #f2f4f7;
          color: #6941c6;
          border-radius: 8px;
          padding: 12px 20px;
          border: 1px solid #eaecf0;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          font-weight: 500;
          font-size: 16px;
        }
      }
    }
  }

  .your_personal_wrapper {
    margin-top: 40px;
    border-radius: 8px;
    border: 1px solid #eaecf0;
    padding: 24px;
    .text {
      color: #667085;
      font-weight: 400;
      font-size: 16px;
    }
    .lci_btn {
      border-radius: 8px;
      padding: 12px 20px;
      border: 1px solid #eaecf0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 240px;
      font-weight: 500;
      font-size: 16px;
      background-color: #7f56d9;
      color: #fff;

      @media (max-width: 576px) {
        width: 100%;
      }
    }
  }
  .video_player_wrapper {
    padding: 24px;
    .text {
      color: #667085;
      font-weight: 400;
      font-size: 16px;
    }

.discover_video_btn{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 12px 20px;
  border: 2px solid #d0d5dd;
  color: #667085;
  min-width: 200px;
  height: 48px;
}
  }
    .personalize_profile {
    margin-top: 40px;
    border-radius: 8px;
    background-color: #7f56d9;
    color: #fff;
    padding: 15px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
    }
    .text {
      color: #fff;
      font-weight: 400;
      font-size: 16px;
    }
    .item_wrap {
      display: flex;
      gap: 20px;
      align-items: center;
    }
    .recommended {
      background-color: #fff;
      color: #7f56d9;
      font-size: 16px;
      font-weight: 500;

      padding: 2px 8px 2px 8px;
      border-radius: 16px;
    }
    .last_section {
      background-color: #fff;
      height: 32px;
      width: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .color {
    color: #6941c6;
  }
}

::v-deep .input_with_custom_text_area .el-textarea__inner {
  word-break: break-word !important; /* Ensures long words break */
  overflow-wrap: break-word !important; /* Ensures text wraps properly */
  white-space: pre-wrap !important; /* Preserves line breaks */
}

/* ===== Loader Overlay ===== */
.notebook-print-loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.notebook-print-loader-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  min-width: 260px;
}

.nb-loader-spinner {
  width: 52px;
  height: 52px;
  border: 5px solid #e9d7fe;
  border-top-color: #7f56d9;
  border-radius: 50%;
  animation: nb-spin 0.85s linear infinite;
}

@keyframes nb-spin {
  to { transform: rotate(360deg); }
}

.nb-loader-text {
  color: #344054;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
  text-align: center;
}

.fade-loader-enter-active,
.fade-loader-leave-active {
  transition: opacity 0.25s ease;
}
.fade-loader-enter,
.fade-loader-leave-to {
  opacity: 0;
}

/* ===== Hidden print container (screen) ===== */
.print-only-block {
  position: absolute !important;
  left: -9999px !important;
  top: -9999px !important;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
  visibility: hidden !important;
}

/* ===== Notebook print styles ===== */
@media print {
  .print-only-block {
    position: static !important;
    left: auto !important;
    top: auto !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    visibility: visible !important;
    display: block !important;
  }

  .notebook-print-loader-overlay {
    display: none !important;
  }

  html, body, #app, .wrapper, .main-panel, .content, .main_profile_wrapper {
    position: static !important;
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #fff !important;
  }

  @page {
    size: auto;
    margin: 8mm 10mm 12mm 10mm !important;
  }

  * {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .subtopic-print-header {
    page-break-after: avoid !important;
    break-after: avoid-page !important;
  }

  .print-page-break {
    page-break-after: always !important;
    break-after: page !important;
    padding: 2mm !important;
    box-sizing: border-box !important;
  }

  .page-break-inside-avoid {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .component-print-block {
    width: 100% !important;
    max-width: 100% !important;
    padding: 8px !important;
    margin-bottom: 8px !important;
    box-sizing: border-box !important;
  }

  .component-print-block + .component-print-block {
    page-break-before: always !important;
    break-before: page !important;
  }

  .notebook-print-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    padding: 1mm 1mm !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .nb-print-user-header {
    padding-bottom: 8px !important;
    margin-bottom: 10px !important;
    border-bottom: 1px solid #7f56d9 !important;
  }

  .nb-print-score-grid {
    margin-top: 10px !important;
    margin-bottom: 15px !important;
    gap: 8px !important;
  }

  .nb-print-score-card {
    padding: 8px 10px !important;
    .nb-card-top-name {
      margin-bottom: 4px !important;
    }
    .nb-card-bottom-icon {
      margin-top: 4px !important;
    }
  }

  .nb-group-header {
    margin-bottom: 12px !important;
    padding: 10px !important;
  }

  .subtopic-print-header {
    margin-bottom: 8px !important;
  }

  .student_notebook_print_card {
    padding: 10px !important;
    margin-bottom: 12px !important;
  }

  .essay-question-container {
    margin-bottom: 8px !important;
    .essay-question-header {
      padding: 8px 12px !important;
    }
    .essay-question-body {
      padding: 8px 12px !important;
    }
    .essay-answer-preview {
      padding: 8px 10px !important;
      min-height: 40px !important;
    }
  }

  .choice-row {
    padding: 6px 10px !important;
    margin-bottom: 4px !important;
  }

  .student_notebook_wrapper,
  .component-body {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;

    table {
      width: 100% !important;
      max-width: 100% !important;
      table-layout: fixed !important;
      border-collapse: collapse !important;
    }
    img, iframe, video {
      max-width: 100% !important;
      height: auto !important;
    }
  }

  .nb-notebook-body {
    padding: 10px !important;
    font-size: 13px !important;
  }
}

/* ===== Notebook print layout (both screen+print) ===== */
.notebook-print-wrapper {
  width: 100%;
  padding: 4mm;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #101828;
}

.nb-print-user-header {
  border-bottom: 2px solid #7f56d9;
  padding-bottom: 14px;
  margin-bottom: 20px;
}

.nb-user-name {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #101828;
}

.nb-user-email {
  font-size: 13px;
  color: #667085;
  margin: 0 0 16px;
}

/* ===== Printed Score Cards (Grid Layout matching attachment style) ===== */
.nb-print-score-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 15px;
  margin-bottom: 25px;
  width: 100%;
}

.nb-print-score-card {
  border-radius: 8px;
  padding: 10px 12px;
  color: #fff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: left;
  page-break-inside: avoid;
  break-inside: avoid;
}

.nb-card-top-name {
  font-size: 13px;
  font-weight: 500;
  opacity: 1;
  margin-bottom: 8px;
}

.nb-card-middle-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
}

.nb-card-score {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.nb-card-level {
  font-size: 12px;
  font-weight: 600;
  opacity: 0.95;
}

.nb-card-bottom-icon {
  display: flex;
  justify-content: center;
  margin-top: 8px;
  font-size: 11px;
  opacity: 0.85;
}


.nb-section-title {
  font-size: 17px;
  font-weight: 700;
  color: #344054;
  border-left: 4px solid #7f56d9;
  padding-left: 10px;
  margin: 0 0 16px;
}

.nb-notebook-block {
  border: 1px solid #eaecf0;
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
}

.nb-notebook-header {
  background: #f9f5ff;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e9d7fe;
}

.nb-notebook-name {
  font-weight: 700;
  font-size: 15px;
  color: #53389e;
}

.nb-notebook-grade {
  background: #7f56d9;
  color: #fff;
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
}

.nb-notebook-body {
  padding: 14px 16px;
  font-size: 14px;
  line-height: 1.7;
  color: #344054;

  ::v-deep {
    table { width: 100% !important; border-collapse: collapse !important; }
    img, iframe, video { max-width: 100% !important; height: auto !important; }
    ul, ol { padding-left: 20px; }
  }
}

.nb-empty-section {
  text-align: center;
  color: #98a2b3;
  padding: 30px;
  font-size: 15px;
}

</style>
